// SVG looks for the sticker materials (preview only — the print file never includes these) and the finish sheen.
import { materialOf } from "./stickerModel";

export const MaterialDefs = ({ id }) => (
  <defs>
    <linearGradient id={`${id}-holo`} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stopColor="#ffd1f3" /><stop offset="0.2" stopColor="#c9f3ff" /><stop offset="0.4" stopColor="#d9ffd1" /><stop offset="0.6" stopColor="#fff4c2" /><stop offset="0.8" stopColor="#f0ccff" /><stop offset="1" stopColor="#c2e2ff" />
    </linearGradient>
    <linearGradient id={`${id}-chrome`} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#f4f6f9" /><stop offset="0.45" stopColor="#aeb6c2" /><stop offset="0.5" stopColor="#6c7684" /><stop offset="0.55" stopColor="#c7ced8" /><stop offset="1" stopColor="#eef1f5" />
    </linearGradient>
    <linearGradient id={`${id}-sheen`} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0.35" stopColor="#fff" stopOpacity="0" /><stop offset="0.5" stopColor="#fff" stopOpacity="0.55" /><stop offset="0.62" stopColor="#fff" stopOpacity="0" />
    </linearGradient>
    <pattern id={`${id}-checker`} width="0.25" height="0.25" patternUnits="userSpaceOnUse">
      <rect width="0.25" height="0.25" fill="#e9ecf1" /><rect width="0.125" height="0.125" fill="#cfd4dc" /><rect x="0.125" y="0.125" width="0.125" height="0.125" fill="#cfd4dc" />
    </pattern>
    <filter id={`${id}-glitter`} x="0" y="0" width="1" height="1">
      <feTurbulence type="fractalNoise" baseFrequency="18" numOctaves="2" seed="7" result="n" />
      <feColorMatrix in="n" type="matrix" values="0 0 0 0 0.86  0 0 0 0 0.74  0 0 0 0 0.95  0 0 0 2.2 -0.9" result="g" />
      <feComposite in="g" in2="SourceGraphic" operator="in" />
    </filter>
  </defs>
);

// Fill for the material under the sticker, keyed to the defs above.
export const materialFill = (doc, id) => {
  const m = materialOf(doc);
  if (m.bg === "holo") return `url(#${id}-holo)`;
  if (m.bg === "chrome") return `url(#${id}-chrome)`;
  if (m.bg === "clear") return `url(#${id}-checker)`;
  if (m.bg === "glitter") return "#d9c6ea";
  return m.bg;
};
export const materialFilter = (doc, id) => (materialOf(doc).bg === "glitter" ? `url(#${id}-glitter)` : undefined);
export const sheenOpacity = (doc) => { const base = materialOf(doc).sheen || 0; const k = doc.finish === "gloss" ? 1.2 : doc.finish === "uv" ? 1.4 : doc.finish === "matte" ? 0.3 : 1; return Math.min(0.9, base * k); };
